/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListMeta2
 */
export interface ListMeta2 {
    /**
     * Amount of items in the system
     * @type {number}
     * @memberof ListMeta2
     */
    total: number;
    /**
     * Displayed page
     * @type {number}
     * @memberof ListMeta2
     */
    page: number;
    /**
     * Elements displayed per page
     * @type {number}
     * @memberof ListMeta2
     */
    pageSize?: number | null;
}

/**
 * Check if a given object implements the ListMeta2 interface.
 */
export function instanceOfListMeta2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function ListMeta2FromJSON(json: any): ListMeta2 {
    return ListMeta2FromJSONTyped(json, false);
}

export function ListMeta2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ListMeta2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'page': json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
    };
}

export function ListMeta2ToJSON(value?: ListMeta2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'page': value.page,
        'pageSize': value.pageSize,
    };
}

